import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useNavigate } from "react-router-dom";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: (theme.vars ?? theme).palette.text.secondary,
  maxWidth: 400,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));

const btm= {    bottom: '0',    position: 'absolute'};

const handleHoverIn = (event) => {
  console.log("Hover In");
  };

const handleHoverOut = () => {
  console.log("Hover Out");
};

const storedObject = localStorage.getItem('eventDetails');
const parsedObject = JSON.parse(storedObject);
const eventName = parsedObject?.eventName;
const eventImage = parsedObject?.eventImage;
const eventCode = parsedObject?.eventCode;
console.log(parsedObject?.eventName); // Output: John



export default function ZeroWidthStack() {

const navigate = useNavigate();
const handleRecent = () => {
  navigate(`explore/${eventCode}`)
};
  

return (
    
      <Box sx={{ flexGrow: 1, overflow: 'hidden', px: 3 }} style={btm}>
      
      {/* <Item sx={{ my: 1, mx: 'auto', p: 2 }}>
        <Stack spacing={2} direction="row" sx={{ alignItems: 'center' }}>
          <Avatar>W</Avatar>
          <Typography noWrap>{eventName}</Typography>
        </Stack>
      </Item> */}
      {eventName? (      
      <Item sx={{ my: 1, mx: 'auto', p: 2 }}
        onMouseEnter={handleHoverIn}
        onMouseLeave={handleHoverOut}
        onClick={handleRecent}
        >
        <Stack spacing={2} direction="row" sx={{ alignItems: 'center' }} >          
          <Stack>
            <Avatar src={eventImage} alt={eventName}></Avatar>
          </Stack>
          <Stack sx={{ minWidth: 0 }}>
            <Typography noWrap>
              {eventName}  
            </Typography>
          </Stack>          
        </Stack>       
      </Item>
      ):
    ('')}
    </Box>          
  );
}
